import type { Editor } from '@tiptap/react';

// 'paragraph' — drag-handle inserted a new paragraph wrapping '/'; cleanup deletes the whole node.
// 'inline'   — drag-handle inserted '/' inside an existing textblock; cleanup deletes the slash plus
//              any characters the user typed into the suggestion query (range.to grows via onUpdate).
export type SlashCleanup =
  | { kind: 'paragraph'; from: number }
  | { kind: 'inline'; from: number; to: number };

const pending = new WeakMap<Editor, SlashCleanup>();

export function markProgrammaticSlash(editor: Editor, cleanup: SlashCleanup): void {
  pending.set(editor, cleanup);
}

export function consumeProgrammaticSlash(editor: Editor): SlashCleanup | null {
  const cleanup = pending.get(editor);
  if (cleanup) {
    pending.delete(editor);
    return cleanup;
  }
  return null;
}

export function updateInlineSlashEnd(editor: Editor, to: number): void {
  const existing = pending.get(editor);
  if (existing && existing.kind === 'inline') {
    pending.set(editor, { ...existing, to });
  }
}

export function hasProgrammaticSlash(editor: Editor): boolean {
  return pending.has(editor);
}
